import { render, staticRenderFns } from "./AccountStatus.vue?vue&type=template&id=6970a354&scoped=true"
import script from "./AccountStatus.vue?vue&type=script&lang=js"
export * from "./AccountStatus.vue?vue&type=script&lang=js"
import style0 from "./AccountStatus.vue?vue&type=style&index=0&id=6970a354&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6970a354",
  null
  
)

export default component.exports